import React, { useState, useEffect } from 'react';
import './LiveDonationDisplay.css';

const LiveDonationDisplay = () => {
    const [donations, setDonations] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Fetch donations immediately
        fetchDonations();

        // Auto-refresh every 2 seconds for real-time updates
        const interval = setInterval(() => {
            fetchDonations();
        }, 20000);

        return () => clearInterval(interval);
    }, []);

    const fetchDonations = async () => {
        try {
            const response = await fetch('https://hospital.rozeetechnist.com/hospital-api/getLiveDonations.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    date: new Date().toISOString().split('T')[0] // Today's date
                })
            });

            const result = await response.json();

            if (result.status) {
                setDonations(result.data || []);

                // Use total amount of ALL donations today (including announced) from API
                if (result.total_donations_amount_today !== undefined) {
                    setTotalAmount(result.total_donations_amount_today);
                } else {
                    // Fallback: Calculate from pending donations if API doesn't return total
                    const total = result.data.reduce((sum, donation) => {
                        return sum + parseFloat(donation.donation_amount.replace(/,/g, ''));
                    }, 0);
                    setTotalAmount(total);
                }

                setIsLoading(false);
            } else {
                setDonations([]);
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error fetching donations:', error);
            setIsLoading(false);
        }
    };

    const formatAmount = (amount) => {
        return parseFloat(amount.toString().replace(/,/g, '')).toLocaleString('en-IN', {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        });
    };

    return (
        <div className="live-display-container">
            <div className="display-header">
                <div className="header-content">
                    <h1 className="display-title">સુમરા હોસ્પિટલ</h1>
                    <h2 className="display-subtitle">Live Donation Updates</h2>
                    <div className="total-amount-display">
                        <span className="total-label">Total Donations:</span>
                        <span className="total-value">₹{formatAmount(totalAmount)}</span>
                    </div>
                </div>
            </div>

            <div className="display-content">
                {isLoading ? (
                    <div className="loading-display">
                        <div className="spinner-large"></div>
                        <p>Loading donations...</p>
                    </div>
                ) : donations.length === 0 ? (
                    <div className="empty-display">
                        <div className="empty-icon-large">🎉</div>
                        <h3>Thank You for Your Support!</h3>
                    </div>
                ) : (
                    <div className="donations-list">
                        {donations.map((donation, index) => (
                            <div
                                key={donation.id}
                                className="donation-item"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="donation-card">
                                    <div className="card-content">
                                        <div className="donor-info">
                                            <span className="donor-name-large">{donation.name}</span>
                                            <span className="donor-city">{donation.city_name}</span>
                                        </div>
                                        <div className="donation-amount-large">
                                            ₹{donation.donation_amount}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="display-footer">
                <p className="update-time">Last updated: {new Date().toLocaleTimeString()}</p>
            </div>
        </div>
    );
};

export default LiveDonationDisplay;
